var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.month)?_c('div',{staticClass:"h2midashi"},[_c('BaseText',{staticClass:"h2midashi-text"},[_vm._v(" "+_vm._s(_vm.month)+"月号 ")])],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }